// Keep in sync with $header-mobile-point in scss/variables/_breakpoints.scss.
export const HEADER_MOBILE_BREAKPOINT = 1199;
